<template>
  <div style="background: linear-gradient(45deg, #28a745, #20c997)">
    <layouts-header />

    <!-- breadcrumb-bar -->
    <div class="breadcrumb-bar bg-transparent">
      <div class="container">
        <div class="row align-items-center text-center col-md-12 col-12">
          <h2 class="breadcrumb-title">خدماتنا</h2>
          <p class="text-white">
            فيك تختار الخدمة يلي بتناسبك <br />
            قدام كل خدمة في شرح عنها مشان ما تحتار<br />
            تأكد اننا اخترنا هي الخدمات بعناية مشان نقدر نساعدك اكتر
          </p>
        </div>
      </div>
    </div>
    <!-- /breadcrumb-bar -->

    <!-- Service Cards -->
    <div class="services-section">
      <section class="service-grid">
        <div
          v-for="(service, index) in services"
          :class="[service.class, 'service-card']"
          :key="index"
        >
          <h2>{{ service.title }}</h2>
          <p>{{ service.description }}</p>
          <button @click="openPopup(service)">
            {{ service.button }}
          </button>
        </div>
      </section>

      <footer class="footer-note">
        اذا في شي بيخليك احنا ما تذكرناه ابعتلنا شو بتحب احنا متصلين فيك
      </footer>
    </div>

    <!-- Modal -->
    <div v-if="showPopup" class="modal-overlay" @click.self="closePopup">
      <div class="modal-content">
        <h3 class="modal-title">
          الخدمات المتوفرة لـ {{ selectedService.title }}
        </h3>
        <div class="modal-cards">
          <div
            v-for="plan in selectedPlans"
            :key="plan.id"
            class="modal-card"
            :class="{ active: selectedPlan === plan.id }"
            @click="selectPlan(plan.id)"
          >
            <p class="p-large">{{ plan.name }}</p>
            <p>المدة: {{ plan.days }}</p>
            <p>السعر: {{ plan.price }}</p>
            <button>اشترك</button>
          </div>
        </div>

        <p class="no-car-msg">الرجاء اضافة سيارة لاضافة الخدمة</p>

        <div class="row">
          <div
            class="col-lg-4 col-md-6 col-12"
            v-for="item in paginatedCars"
            :key="item.id"
            data-aos="fade-down"
            :class="{ active: selectedCars.includes(item.id) }"
            @click="toggleCar(item.id)"
          >
            <div class="listing-item bike-list my-4">
              <div class="listing-img">
                <img
                  :src="
                    item.images[0]?.image ||
                    require('@/assets/img/cars/no-car.jpg')
                  "
                  class="img-fluid"
                  alt="car"
                />
              </div>
              <div class="listing-content">
                <div class="listing-features d-flex justify-content-between">
                  <div class="list-rating">
                    <div>
                      <span class="featured-text">{{
                        timeAgo(item.created_at)
                      }}</span>
                    </div>
                    <span class="featured-text"
                      >{{ item.brand?.name }} - {{ item.model?.name }}</span
                    >
                  </div>
                  <div class="list-km">
                    <span class="km-count"
                      ><img
                        src="@/assets/img/icons/map-pin.svg"
                        alt="author"
                      />{{ item.city?.name }} - {{ item.district?.name }}
                    </span>
                  </div>
                </div>
                <div class="listing-details-group">
                  <ul>
                    <li>
                      <span
                        ><img
                          src="@/assets/img/icons/car-parts-05.svg"
                          alt="Manual"
                      /></span>
                      <p>&nbsp; {{ item.gear }}</p>
                    </li>
                    <li>
                      <span
                        ><img
                          src="@/assets/img/icons/car-parts-02.svg"
                          alt="18 KM"
                      /></span>
                      <p>&nbsp; {{ item.kilometers }}</p>
                    </li>
                    <li>
                      <span
                        ><img
                          src="@/assets/img/icons/car-parts-03.svg"
                          alt="Diesel"
                      /></span>
                      <p>&nbsp; {{ item.fuel_type }}</p>
                    </li>

                    <li>
                      <span
                        ><img
                          src="@/assets/img/icons/car-parts-05.svg"
                          alt="2018"
                      /></span>
                      <p>&nbsp; {{ item.year }}</p>
                    </li>
                  </ul>
                </div>
                <div class="listing-button">
                  <!-- <div class="listing-price">
                        <h6>{{ item.price }} <span>جنيه</span></h6>
                      </div> -->
                  <div class="listing-price">
                    <h6 v-if="item.rent_or_sale == 'rent'">
                      ${{ item.price?.daily }}
                      <span>/ يوم</span>
                    </h6>
                    <h6 v-else-if="item.rent_or_sale == 'installment'">
                      ${{ item.installment?.price }}
                    </h6>
                    <h6 v-else>${{ item.price }}</h6>
                  </div>
                  <div class="d-flex align-items-center">
                    <a
                      href="javascript:void(0)"
                      class="fav-icon"
                      @click="toggleSelected(item)"
                      :class="{ selected: item.is_fav }"
                    >
                      <i class="feather-heart"></i>
                    </a>
                    <router-link
                      :to="`/listing/${item.id}`"
                      class="btn btn-order"
                      >تفاصيل</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-4" v-if="totalPages > 1">
          <button
            class="btn btn-outline-primary mx-2"
            :disabled="currentPage === 1"
            @click="prevPage"
          >
            السابق
          </button>

          <span class="align-self-center"
            >صفحة {{ currentPage }} من {{ totalPages }}</span
          >

          <button
            class="btn btn-outline-primary mx-2"
            :disabled="currentPage === totalPages"
            @click="nextPage"
          >
            التالي
          </button>
        </div>

        <b-button
          class="confirm-btn"
          @click="submitService"
          :disabled="serviceStore.isLoading"
        >
          تأكيد الاشتراك

          {{ serviceStore.isLoading ? "جارى التحميل" : "تأكيد الاشتراك" }}
          <i
            v-if="serviceStore.isLoading"
            class="fas fa-spinner fa-spin me-2"
          ></i>
        </b-button>
      </div>
    </div>

    <layout-footer />
  </div>
</template>

<script setup>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

import { onMounted, computed, ref } from "vue";
import { useServicesStore } from "@/stores/services";
import { useCarStore } from "@/stores/car";
import { useFavoriteStore } from "@/stores/favorite";
import { showAlert } from "@/composables/useAlert";

const serviceStore = useServicesStore();
const carStore = useCarStore();
const favoriteStore = useFavoriteStore();

const showPopup = ref(false);
const selectedPlan = ref(null);
const selectedCars = ref([]);
const selectedService = ref("");
const selectedPlans = ref({});
const allServices = ref({});

const currentPage = ref(1);
const itemsPerPage = ref(3);

onMounted(() => {
  loadAllServices();
  loadMyCars();
});

function nextPage() {
  if (currentPage.value < totalPages.value) currentPage.value++;
}
function prevPage() {
  if (currentPage.value > 1) currentPage.value--;
}

function timeAgo(date) {
  if (!date) return "";
  const now = new Date();
  const created = new Date(date);
  const diff = Math.floor((now - created) / 1000);

  if (diff < 60) return "منذ ثوانٍ";
  if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
  if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
  if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
  if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
  return `منذ ${Math.floor(diff / 31104000)} سنة`;
}

async function loadServices(type) {
  await serviceStore.getServiceByType(type);
  allServices[type] = serviceStore.services || [];
}

async function loadAllServices() {
  await Promise.all(services.map((s) => loadServices(s.name)));
}

const loadMyCars = async () => {
  carStore.getMyCars().then(() => {});
};
const myCars = computed(() => carStore.myCars);

const totalPages = computed(() =>
  Math.ceil(myCars.value.length / itemsPerPage.value)
);
const paginatedCars = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return myCars.value.slice(start, end);
});

const openPopup = (service) => {
  selectedService.value = service;
  showPopup.value = true;
  selectedPlans.value = allServices[selectedService.value.name];
};

const closePopup = () => {
  selectedPlan.value = null;
  selectedCars.value = [];
  showPopup.value = false;
};

const selectPlan = (plan) => {
  selectedPlan.value = plan;
};
const toggleCar = (carId) => {
  const index = selectedCars.value.indexOf(carId);
  if (index === -1) {
    selectedCars.value.push(carId);
  } else {
    selectedCars.value.splice(index, 1);
  }
};
function toggleSelected(item) {
  favoriteStore.toggleFavorite(item.id);

  item.isSelected = !item.isSelected;
  item.is_fav = !item.is_fav;
}

const submitService = () => {
  if (!selectedPlan.value || !selectedCars.value.length) {
    showAlert("الرجاء اختيار خطة وسيارة قبل التأكيد.");
    return;
  }
  serviceStore
    .addServiceRequest(selectedPlan.value, selectedCars.value)
    .then(() => {
      showAlert("تم طلب الخدمة بنجاح", "success");
      closePopup();
    });
};
const services = [
  {
    title: "الإعلان المميز",
    description: "بينزل سيارتك بأول عشرة فرصتك اكبر بالبيع السريع",
    button: "خلي اعلاني مميز",
    class: "green",
    name: "feature_ad",
  },
  {
    title: "صور رييلز",
    description: "الرييلز بيطلع اول شي بالبحث الفيديو دايمًا اوضح",
    button: "حمل الفيديو تبعي",
    class: "green",
    name: "real",
  },
  {
    title: "التقرير الفني",
    description: "يخلي سيارتك موثوقة",
    button: "اطلب الفحص",
    class: "red",
    name: "check",
  },
  {
    title: "ابعتلي اشعارات",
    description: "الاشعارات لكل المهتمين بنوع سيارتك بتخلي السيارة تباع بساعات",
    button: "ابعتلي",
    class: "red",
    name: "notification_ad",
  },
  {
    title: "مزايا المصارف",
    description: "اذا كنت مصرفي تأكد",
    button: "خلي اعلاني مميز",
    class: "black",
    name: "agency_feature",
  },
  {
    title: "الإعلان التجاري",
    description: "الإعلانات التجارية تظهر بالرئيسية",
    button: "خلي اعلاني مميز",
    class: "black",
    name: "home_ad",
  },
];
</script>

<style scoped>
.services-section {
  background: white;
  padding: 40px 20px;
  color: #333;
  min-height: 100vh;
}
.service-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
}
@media (min-width: 600px) {
  .service-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.service-card {
  padding: 20px;
  border-radius: 10px;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.service-card h2 {
  margin-bottom: 10px;
  font-size: 1.2rem;
  color: white;
}
.service-card p {
  margin-bottom: 12px;
}
.service-card button {
  padding: 6px 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: white;
}
.service-card.green {
  background-color: #28a745;
}
.service-card.green button {
  color: #28a745;
}
.service-card.red {
  background-color: #dc3545;
}
.service-card.red button {
  color: #dc3545;
}
.service-card.black {
  background-color: #000;
}
.service-card.black button {
  color: #000;
}
.footer-note {
  text-align: center;
  font-size: 0.8rem;
  color: #666;
  margin-top: 40px;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 30px 20px;
  width: 90%;
  /* max-width: 800px; */
  border-radius: 12px;
  text-align: center;
  position: relative;
  overflow-y: auto;
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  gap: 20px;
}

.modal-title {
  margin-bottom: 20px;
  color: #28a745;
}
.modal-cards {
  display: flex;
  flex-wrap: nowrap;
  /* overflow-x: auto; */
  gap: 15px;
  scroll-snap-type: x mandatory;
}

.modal-card {
  min-width: 200px;
  scroll-snap-align: start;
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 8px;
  background: #fff;

  /* flex: 1 1 45%; */
  flex: 0 0 auto;
  transition: all 0.3s ease;
  cursor: pointer;
}

.modal-card.active,
.active {
  border: 2px solid #28a745;
  background-color: #f4fff6;
}

.modal-card button {
  margin-top: 10px;
  background-color: #f1f1f1;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  font-weight: bold;
  color: #28a745;
}

.no-car-msg {
  margin-bottom: 20px;
  font-size: 0.95rem;
  color: #444;
  border-top: 1px solid #ccc;
  padding-top: 10px;
}

.confirm-btn {
  width: 100%;
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
}
.p-large {
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
